<template>
  <div>
    <div class="d-flex align-items-center gap-lg-1 ai_answer mb-3">
      <div class="bg-white rounded-circle p-1">
        <AssistantIcon :height="32" :width="32" />
      </div>
      <div>
        <span class="horizontal_border"></span>
      </div>
      <div>
        <p v-if="fullFillMentText" class="mb-0">
          {{
            fullFillMentText
          }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>

import AssistantIcon from '../icons/AssistantIcon.vue';
// import AiVehicleInfo from './AiVehicleInfo.vue';

export default {
  components: {
    // AiVehicleInfo,
    AssistantIcon
    // AiCoupons
  },
  props: {
    fullFillMentText: {
      default: '',
      required: false,
    },
    requesttime: {
      default: '',
      required: false,
    },
    index: {
      default: '',
      required: false,
    },
  }
}
</script>
<style>
.horizontal_border {
  height: 1.5rem;
  width: 1px;
  background: #66666674;
  display: block;
}

.ai_answer p {
  font-weight: 500;
}

.gap-lg-1 {
  gap: 10px;
}
</style>
